import { VolunteerSortField } from '../../../queries/Volunteer';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components-v2/Select';
import { styleSheet } from './styles';

const SORT_OPTIONS: { value: VolunteerSortField; label: string }[] = [
	{ value: 'lastActivityDate', label: 'Last activity' },
	{ value: 'totalHours', label: 'Total hours' },
];

interface IProps {
	value: VolunteerSortField;
	onChange: (value: VolunteerSortField) => void;
}

export const VolunteerSortSelect = ({ value, onChange }: IProps) => (
	<Select items={SORT_OPTIONS} value={value} onValueChange={next => onChange(next as VolunteerSortField)}>
		<SelectTrigger styles={styleSheet.sortFilterTrigger}>
			<SelectValue />
		</SelectTrigger>
		<SelectContent>
			{SORT_OPTIONS.map(option => (
				<SelectItem key={option.value} value={option.value}>
					{option.label}
				</SelectItem>
			))}
		</SelectContent>
	</Select>
);
